import React from 'react';

const WhyDifficult: React.FC = () => {
  const reasons = [
    {
      title: '全員の同意がなければ売却できない',
      icon: 'ri-user-forbid-line',
      description: '民法第251条により、共有物の変更（売却）には共有者全員の同意が必要です。一人でも反対すれば売却できません。',
      details: [
        '共有者の一人が「売りたくない」と言えば売却不可',
        '共有者が多数いる場合、全員の意見をまとめるのは困難',
        '共有者間で価格の希望が異なると話がまとまらない'
      ]
    },
    {
      title: '共有者と連絡が取れない・話がまとまらない',
      icon: 'ri-question-line',
      description: '相続が何代も続いていると、共有者が誰なのか、どこに住んでいるのかさえわからないケースがあります。',
      details: [
        '疎遠な親戚が共有者になっている',
        '共有者が高齢で判断能力が低下している',
        '共有者が海外に住んでいて連絡が取りづらい',
        '感情的な対立があり、話し合いができない'
      ]
    },
    {
      title: '相続登記が終わっていない',
      icon: 'ri-file-forbid-line',
      description: '親の代から相続登記をしていないと、法定相続人全員が共有者となり、さらに複雑化します。',
      details: [
        '相続人が10人以上になっているケースも',
        '遺産分割協議書がないと登記ができない',
        '相続人の中に行方不明者がいる',
        '令和6年4月から相続登記が義務化され、放置できなくなった'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            共有名義の不動産はなぜ処分が難しいのか
          </h2>
          <p className="text-xl text-gray-600">
            法律上の制約と実務上の問題
          </p>
        </div>

        <div className="max-w-6xl mx-auto space-y-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border-2 border-gray-200 hover:border-orange-300 hover:shadow-xl transition-all duration-200"
            >
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0 mr-6">
                  <i className={`${reason.icon} text-3xl text-red-600`}></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {reason.title}
                  </h3>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </div>

              <div className="ml-0 md:ml-22 bg-white rounded-lg p-6 border border-gray-200">
                <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-alert-line text-red-500 mr-2"></i>
                  具体的な問題
                </h4>
                <ul className="space-y-2">
                  {reason.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start text-gray-700">
                      <span className="text-red-500 mr-2 mt-1">●</span>
                      <span>{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 p-8 bg-orange-50 rounded-2xl max-w-4xl mx-auto border-2 border-orange-200">
          <p className="text-xl font-bold text-gray-900 mb-3">
            これらの問題を放置すると…
          </p>
          <p className="text-gray-700 leading-relaxed">
            固定資産税の負担が続き、さらに相続が発生して共有者が増え、<br />
            ますます処分が困難になります。<br />
            <strong className="text-orange-600">早めの対応が重要です。</strong>
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyDifficult;
